import { useTranslation } from 'next-i18next'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'
import SeoHead from '@/components/seo/SeoHead'

export default function PageTermsOfUse() {
  const { t } = useTranslation('termsOfUse')

  return (
    <>
      <SeoHead
        title={t('title')}
        description={t('description')}
        dePath="terms-of-use"
        enPath="terms-of-use"
      />

      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="terms-of-use" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'termsOfUse'])
export { getStaticPaths, getStaticProps }
